"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServiceWorker = void 0;
const isServiceWorker = () => {
    return (typeof self !== "undefined" &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        typeof ServiceWorkerGlobalScope !== "undefined" &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self instanceof ServiceWorkerGlobalScope);
};
exports.isServiceWorker = isServiceWorker;
//# sourceMappingURL=index.js.map